import ProductWillBeAddedSoon from "../ProductWillBeAddedSoon";

const LaptopPage = () => {
  return <ProductWillBeAddedSoon />;
};

export default LaptopPage;
